import React from 'react';
import {
    Alert
} from "tabler-react";

function LoadingError(props) {
    const {errorMsg} = props;
        return ( <div className="incidents">
            <Alert type="secondary">
            <strong>{errorMsg}</strong>
            </Alert>
        </div>);
}

export default LoadingError;